<app-card>
  <h3>{{ 'devices.history.headline' | translate }}</h3>

  <div class="scroll-wrapper">
    @if (loading && history.length === 0) {
      <p class="history-separator skeleton">
        <span class="skeleton-chip"></span>
      </p>

      <div class="history-group">
        @for (_row of skeletonRows; track $index) {
          <div class="history-item skeleton">
            <p class="time"><span class="skeleton-time"></span></p>
            <p class="skeleton-line"></p>
          </div>
        }
      </div>
    } @else if (history.length > 0) {
      @for (group of history; track trackByGroupDate($index, group)) {
        <p class="history-separator">
          <span><b>{{ getDate(group.date) | localizedDate:'EEEE' }},</b> {{ getDate(group.date) | localizedDate }}</span>
        </p>

        <div class="history-group">
          @for (item of group.items; track trackByItemEventId($index, item)) {
            <div class="history-item">
              <p class="time">{{ item.eventDate | time:'noSuffix' }}</p>
              @if (isScenarioHistoryEntry(item)) {
                <p [innerHTML]="getLabel(item) | translate:getLabelParams(item)"></p>
              } @else {
                <p>{{ getLabel(item) | translate:getLabelParams(item) }}</p>
              }
            </div>
          }
        </div>
      }
    } @else {
      {{ 'devices.history.empty' | translate }}
    }
  </div>

  @if (canLoadMore) {
    <button type="button" class="button center" (click)="onLoadMore()">{{ 'devices.history.more' | translate }}</button>
  }
</app-card>
